import { TypeAheadDTO } from "~app/common/models/common/TypeAheadDTO";

// HandelssortimentBasDataModel
export interface IHandelssortimentgrunddata {
    sortimentLista: ISortiment[];
    handelssortimentsgruppLista: IHandelssortimentsgrupp[];
    produktLista: IProdukt[];
    fordelningstyper: string[];
    lagerenheter: string[];
    foreslagnaMattslag: string[];
}

export interface IHandelssortimentTypeAhead extends TypeAheadDTO {
    violId?: string;
    beraknatInmatningshandelssortiment?: {
        violId: string;
        namn: string;
        id: number;
        aktiv: boolean;
    };
}

export interface ISortiment {
    id: number;
    kod: string;
    namn: string;
    marked: boolean;
}

export interface IHandelssortimentsgrupp {
    id: number;
    kod: string;
    namn: string;
    beskrivning: string;
    sekvensnummer: number;
    compatibleProduktHandelssortimentsgruppKoder: string[];
}

export interface IProdukt {
    id: number;
    namn: string;
    beteckning: string;
    prodgrupp: string;
    aktiv: boolean;
    handelssortimentsgruppId: number;
}

// HandelssortimentModel
export interface IHandelssortiment {
    ignoreWarnings: boolean;
    id: number;
    beteckning: string;
    aktiv: boolean;
    namn: string;
    beskrivning: string;
    handelssortimentsgruppId: number;
    lagerenhet: string;
    sortimentIdLista: number[];
    handelssortimentProdukter: IHandelssortimentProdukt[];
    giltigFrom: Date;
    giltigTom: Date;
    skapadAv: string;
    rowVersion: string;
    huvudsortimentId: number;
    relateradeHandelssortiment: IRelateratHandelssortiment[];
    relateratHandelssortiment: IRelateratHandelssortiment;
    ravaruhandelssortiment: IRavaruHandelssortiment;
    isRefereratFranKundorderrad: boolean;
    foreslagetMattslag: string;
    violId: string;
    forInmatning: boolean;
    forProduktion: boolean;
    inmatningshandelssortiment: IInmatningshandelssortiment;
}

export interface IHandelssortimentProdukt {
    produktId: number;
    fordelningstyp: string;
    andel: number;
    rowVersion: string;
}

export interface IDeleteHandelssortiment {
    id: number;
    rowVersion: string;
}

export interface ISearchHandelssortimentModel {
    aktiv: boolean;
    id: number;
    guid: string;
    produkter: IEmbeddedEntityReference[];
    handelssortimentsgrupp: IEmbeddedEntityReference;
    sortiment: IEmbeddedSortiment[];
    giltighetFrom: string;
    giltighetTom: string;
    namn: string;
    foreslagetMattslag: string;
    beteckning: string;
    violId: string;
    forInmatning: boolean;
    forProduktion: boolean;
}

export interface ISearchViol3HandelssortimentModel {
    identitet: string;
    namn: string;
    sortimentkategori: string;
}

export interface IEmbeddedSortiment {
    namn: string;
    id: number;
    kod: string;
    isHuvudsortiment: boolean;
}

export interface IEmbeddedEntityReference {
    namn: string;
    id: number;
    beteckning: string;
    kod: string;
    sekvensnummer: number;
}

export interface IInmatningshandelssortiment {
    id: number;
    namn: string;
    aktiv: boolean;
    violId: string;
}

export interface IRelateratHandelssortiment {
    id: number;
    namn: string;
    aktiv: boolean;
}

export interface IRavaruHandelssortiment {
    id: number;
    namn: string;
    aktiv: boolean;
}

// HandelssotrimentListModel
export interface IHandelssortimentList {
    id: number;
    namn: string;
    aktiv: boolean;
    beteckning: string;
    giltighetFrom: Date;
    giltighetTom: Date;
    handelssortimentsgrupp: IHandelssortimentsgrupp[]; // Från handelssortimentBasDataModel
    produkt: IProdukt[];           // Från handelssortimentBasDataModel
    sortiment: ISortiment[];       // Från handelssortimentBasDataModel
}

// HandelssortimentResponseModel
export interface IHandelssortimentListResponse {
    handelssortimentList: IHandelssortimentList[];
}

// HandelssortimentSearchParamsModel
export interface IHandelssortimentSearchParamsModel {
    ids?: number[];
    namn?: string;
    sortimentskod?: string;
    handelssortimentsgrupp?: string;
    produktnamn?: string;
    beteckning?: string;
    aktiv?: boolean;
    aktivFormValue?: string;
    forInmatning?: boolean;
    forProduktion?: boolean;
    sort?: string;
    skipForadlade?: boolean;
    wildcardSearch?: string;
}

export interface IHandelssortimentModifications {
    id: number;
    state: "Added" | "Deleted";
}

export class UpdateMinaHandelssortimentCommand {
    addedHandelssortimentIds: number[];
    deletedHandelssortimentIds: number[];

    constructor(
        addedHandelssortimentIds: number[],
        deletedHandelssortimentIds: number[]) {
        this.addedHandelssortimentIds = addedHandelssortimentIds;
        this.deletedHandelssortimentIds = deletedHandelssortimentIds;
    }
}
